import React from 'react';
import { Retry } from '@src/components/common';
import { FlowContainer } from './styled';
import useAppFlowFetch from '../../hooks/useFlowData';
import type { AppFlowMetadata } from '@src/hooks/flow/useFlowConfigs';
import FlowContent from '../FlowContent/FlowContent';

interface Props {
  flowId: string;
  flowMeta: AppFlowMetadata;
}

const FlowBar = ({ flowId, flowMeta }: Props) => {
  const query = useAppFlowFetch({ flowId, flowMeta });

  return (
    <Retry
      progress
      isLoading={query.isFetching}
      showError={query.isError}
      fetchData={query.refetch}
    >
      <FlowContainer>
        <FlowContent data={query.data ?? { totals: {} }} flowMeta={flowMeta} />
      </FlowContainer>
    </Retry>
  );
};

export default React.memo(FlowBar);
